import { render, staticRenderFns } from "./RepeatSendLogs.table.itemBy.vue?vue&type=template&id=4da7c622&"
import script from "./RepeatSendLogs.table.itemBy.vue?vue&type=script&lang=js&"
export * from "./RepeatSendLogs.table.itemBy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports